import { TagIcon } from "assets/icons";
import Label from "components/foundation/Label/Label";
import React from "react";
import styled from "styled-components";

interface TagListProps {
  list: string[];
}

const TagList = ({ list }: TagListProps) => {
  return (
    <TagListLayout>
      <TagIcon />
      <div className="tag-list__content">
        {list.map((tag) => (
          <Label
            variant="grey"
            key={tag}
            style={{
              backgroundColor: "#DADFE5",
            }}
          >
            <p>{tag}</p>
          </Label>
        ))}
      </div>
    </TagListLayout>
  );
};

export default TagList;

const TagListLayout = styled.div`
  display: flex;

  gap: 0.8rem;

  padding: 1.6rem 2rem;
  border-radius: 1rem;

  background-color: ${({ theme }) => theme.color.grey[200]};

  .tag-list__content {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
  }

  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.color.icon.tertiary};
  }
`;
